import React from 'react';
import { FormattedMessage } from 'react-intl';

import Modal from './../../../../reusable/Modal/Modal.index.jsx';

import { MAX_EXCEL_UPLOAD_SIZE } from './../../../../constants';

function BatchUploadModals(
    {
        stage,
        file,
        handleUpload,
        uploadSelectedFile,
        cancelUpload
    }
) {

    /**
     * Decide if a modal needs to be shown
     */

    var modal = null;

    switch (stage) {

        case 'file-selected':
            // If it's a Excel spreadsheet then ask the user if this is the file he wants to upload an check its size.
            if (file.name.lastIndexOf('.xlsx') === file.name.length - 5 && file.size <= MAX_EXCEL_UPLOAD_SIZE) {

                let buttons = [
                    {
                        text: <FormattedMessage id="General_CoreFunctionality_UIText_general.continue"/>,
                        primary: true,
                        click: handleUpload,
                        tabIndex: "1"
                    },
                    {
                        text: <FormattedMessage id="General_CoreFunctionality_UIText_general.cancel"/>,
                        click: cancelUpload
                    }
                ];

                modal = (
                    <Modal buttons={buttons} closeButtonHandler={cancelUpload}>
                        <h2 className="modal-header">
                            <FormattedMessage
                                id="Entities_Steps_UIText_batchUpload.selectedFileForUpload"/>
                        </h2>
                        <div className="modal-check">
                            <FormattedMessage id="Entities_Steps_UIText_batchUpload.checkFile"/>:
                        </div>
                        <div className="modal-file">
                            <span className="la-Excel"></span>
                            <div className="modal-file__filename">
                                {file.name}
                            </div>
                        </div>
                    </Modal>
                );

                // If it's not an Excel spreadsheet then show an error message
            } else {

                let buttons = [
                    {
                        text: <FormattedMessage id="General_CoreFunctionality_UIText_general.ok"/>,
                        primary: true,
                        click: cancelUpload,
                        tabIndex: "1"
                    }
                ];

                modal = (
                    <Modal buttons={buttons} closeButtonHandler={cancelUpload}>
                        <h2 className="modal-header">
                            <FormattedMessage id="Entities_Steps_Error_batchUpload.invalidFileMsg"/>
                        </h2>
                        <div className="modal-file">
                            <span className="la-Excel"></span>
                            <div className="modal-file__filename">
                                {file.name}
                            </div>
                        </div>
                    </Modal>
                );

            }
            break;

        case 'started':
            modal = (
                <Modal>
                    <h2 className="modal-header">
                        <FormattedMessage
                            id="Entities_Steps_UIText_batchUpload.uploadProgressHeading"/>
                    </h2>
                    <img src="assets/spinner.gif"
                         className="loading-spinner-image"
                         alt="Upload in progress"
                         height="40px"
                         width="40px"
                    />
                    <div className="modal-check">
                        <div className="uploading-progress-messages">
                            <FormattedMessage id="Entities_Steps_UIText_batchUpload.uploadProgressFinishMessage1"/>
                        </div>
                        <div className="uploading-progress-messages">
                            <FormattedMessage id="Entities_Steps_UIText_batchUpload.uploadProgressFinishMessage2"/>
                        </div>
                    </div>
                </Modal>
            );
            break;

        case 'failure':
        default:
            modal = null;

    }
    return modal;
}

export default BatchUploadModals;




// WEBPACK FOOTER //
// ./src/scripts/pages/BatchUpload/submodules/Modals/BatchUpload.modals.jsx